var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotPattern1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 283,
    viewBox: "0 0 240 283",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11_3938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-164 0H-160V4H-164V0Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-144 0H-140V4H-144V0Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-124 0H-120V4H-124V0Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-104 0H-100V4H-104V0Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-84 0H-80V4H-84V0Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-64 0H-60V4H-64V0Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-44 0H-40V4H-44V0Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-24 0H-20V4H-24V0Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4 0H0V4H-4V0Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 0H20V4H16V0Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 0H40V4H36V0Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 0H60V4H56V0Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 0H80V4H76V0Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 0H100V4H96V0Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116 0H120V4H116V0Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136 0H140V4H136V0Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156 0H160V4H156V0Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176 0H180V4H176V0Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196 0H200V4H196V0Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 0H220V4H216V0Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236 0H240V4H236V0Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-164 20H-160V24H-164V20Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-144 20H-140V24H-144V20Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-124 20H-120V24H-124V20Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-104 20H-100V24H-104V20Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-84 20H-80V24H-84V20Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-64 20H-60V24H-64V20Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-44 20H-40V24H-44V20Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-24 20H-20V24H-24V20Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4 20H0V24H-4V20Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 20H20V24H16V20Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 20H40V24H36V20Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 20H60V24H56V20Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 20H80V24H76V20Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 20H100V24H96V20Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116 20H120V24H116V20Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136 20H140V24H136V20Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156 20H160V24H156V20Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176 20H180V24H176V20Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196 20H200V24H196V20Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 20H220V24H216V20Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236 20H240V24H236V20Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-164 40H-160V44H-164V40Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-144 40H-140V44H-144V40Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-124 40H-120V44H-124V40Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-104 40H-100V44H-104V40Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-84 40H-80V44H-84V40Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-64 40H-60V44H-64V40Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-44 40H-40V44H-44V40Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-24 40H-20V44H-24V40Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4 40H0V44H-4V40Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 40H20V44H16V40Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 40H40V44H36V40Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 40H60V44H56V40Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 40H80V44H76V40Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 40H100V44H96V40Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116 40H120V44H116V40Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136 40H140V44H136V40Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156 40H160V44H156V40Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176 40H180V44H176V40Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196 40H200V44H196V40Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 40H220V44H216V40Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236 40H240V44H236V40Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-164 60H-160V64H-164V60Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-144 60H-140V64H-144V60Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-124 60H-120V64H-124V60Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-104 60H-100V64H-104V60Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-84 60H-80V64H-84V60Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-64 60H-60V64H-64V60Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-44 60H-40V64H-44V60Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-24 60H-20V64H-24V60Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4 60H0V64H-4V60Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 60H20V64H16V60Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 60H40V64H36V60Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 60H60V64H56V60Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 60H80V64H76V60Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 60H100V64H96V60Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116 60H120V64H116V60Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136 60H140V64H136V60Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156 60H160V64H156V60Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176 60H180V64H176V60Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196 60H200V64H196V60Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 60H220V64H216V60Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236 60H240V64H236V60Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-164 80H-160V84H-164V80Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-144 80H-140V84H-144V80Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-124 80H-120V84H-124V80Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-104 80H-100V84H-104V80Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-84 80H-80V84H-84V80Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-64 80H-60V84H-64V80Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-44 80H-40V84H-44V80Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-24 80H-20V84H-24V80Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4 80H0V84H-4V80Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 80H20V84H16V80Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 80H40V84H36V80Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 80H60V84H56V80Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 80H80V84H76V80Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 80H100V84H96V80Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116 80H120V84H116V80Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136 80H140V84H136V80Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156 80H160V84H156V80Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176 80H180V84H176V80Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196 80H200V84H196V80Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 80H220V84H216V80Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236 80H240V84H236V80Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-164 100H-160V104H-164V100Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-144 100H-140V104H-144V100Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-124 100H-120V104H-124V100Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-104 100H-100V104H-104V100Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-84 100H-80V104H-84V100Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-64 100H-60V104H-64V100Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-44 100H-40V104H-44V100Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-24 100H-20V104H-24V100Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4 100H0V104H-4V100Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 100H20V104H16V100Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 100H40V104H36V100Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 100H60V104H56V100Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 100H80V104H76V100Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 100H100V104H96V100Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116 100H120V104H116V100Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136 100H140V104H136V100Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156 100H160V104H156V100Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176 100H180V104H176V100Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196 100H200V104H196V100Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 100H220V104H216V100Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236 100H240V104H236V100Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-164 120H-160V124H-164V120Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-144 120H-140V124H-144V120Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-124 120H-120V124H-124V120Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-104 120H-100V124H-104V120Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-84 120H-80V124H-84V120Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-64 120H-60V124H-64V120Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-44 120H-40V124H-44V120Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-24 120H-20V124H-24V120Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4 120H0V124H-4V120Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 120H20V124H16V120Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 120H40V124H36V120Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 120H60V124H56V120Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 120H80V124H76V120Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 120H100V124H96V120Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116 120H120V124H116V120Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136 120H140V124H136V120Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156 120H160V124H156V120Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176 120H180V124H176V120Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196 120H200V124H196V120Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 120H220V124H216V120Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236 120H240V124H236V120Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-164 140H-160V144H-164V140Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-144 140H-140V144H-144V140Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-124 140H-120V144H-124V140Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-104 140H-100V144H-104V140Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-84 140H-80V144H-84V140Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-64 140H-60V144H-64V140Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-44 140H-40V144H-44V140Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-24 140H-20V144H-24V140Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4 140H0V144H-4V140Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 140H20V144H16V140Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 140H40V144H36V140Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 140H60V144H56V140Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 140H80V144H76V140Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 140H100V144H96V140Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116 140H120V144H116V140Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136 140H140V144H136V140Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156 140H160V144H156V140Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176 140H180V144H176V140Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196 140H200V144H196V140Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 140H220V144H216V140Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236 140H240V144H236V140Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-164 160H-160V164H-164V160Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-144 160H-140V164H-144V160Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-124 160H-120V164H-124V160Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-104 160H-100V164H-104V160Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-84 160H-80V164H-84V160Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-64 160H-60V164H-64V160Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-44 160H-40V164H-44V160Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-24 160H-20V164H-24V160Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4 160H0V164H-4V160Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 160H20V164H16V160Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 160H40V164H36V160Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 160H60V164H56V160Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 160H80V164H76V160Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 160H100V164H96V160Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116 160H120V164H116V160Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136 160H140V164H136V160Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156 160H160V164H156V160Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176 160H180V164H176V160Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196 160H200V164H196V160Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 160H220V164H216V160Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236 160H240V164H236V160Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-164 180H-160V184H-164V180Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-144 180H-140V184H-144V180Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-124 180H-120V184H-124V180Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-104 180H-100V184H-104V180Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-84 180H-80V184H-84V180Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-64 180H-60V184H-64V180Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-44 180H-40V184H-44V180Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-24 180H-20V184H-24V180Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4 180H0V184H-4V180Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 180H20V184H16V180Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 180H40V184H36V180Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 180H60V184H56V180Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 180H80V184H76V180Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 180H100V184H96V180Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116 180H120V184H116V180Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136 180H140V184H136V180Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156 180H160V184H156V180Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176 180H180V184H176V180Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196 180H200V184H196V180Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 180H220V184H216V180Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236 180H240V184H236V180Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-164 200H-160V204H-164V200Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-144 200H-140V204H-144V200Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-124 200H-120V204H-124V200Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-104 200H-100V204H-104V200Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-84 200H-80V204H-84V200Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-64 200H-60V204H-64V200Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-44 200H-40V204H-44V200Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-24 200H-20V204H-24V200Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4 200H0V204H-4V200Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 200H20V204H16V200Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 200H40V204H36V200Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 200H60V204H56V200Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 200H80V204H76V200Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 200H100V204H96V200Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116 200H120V204H116V200Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136 200H140V204H136V200Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156 200H160V204H156V200Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176 200H180V204H176V200Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196 200H200V204H196V200Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 200H220V204H216V200Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236 200H240V204H236V200Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-164 220H-160V224H-164V220Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-144 220H-140V224H-144V220Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-124 220H-120V224H-124V220Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-104 220H-100V224H-104V220Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-84 220H-80V224H-84V220Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-64 220H-60V224H-64V220Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-44 220H-40V224H-44V220Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-24 220H-20V224H-24V220Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4 220H0V224H-4V220Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 220H20V224H16V220Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 220H40V224H36V220Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 220H60V224H56V220Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 220H80V224H76V220Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 220H100V224H96V220Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116 220H120V224H116V220Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136 220H140V224H136V220Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156 220H160V224H156V220Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176 220H180V224H176V220Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196 220H200V224H196V220Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 220H220V224H216V220Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236 220H240V224H236V220Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-164 240H-160V244H-164V240Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-144 240H-140V244H-144V240Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-124 240H-120V244H-124V240Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-104 240H-100V244H-104V240Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-84 240H-80V244H-84V240Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-64 240H-60V244H-64V240Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-44 240H-40V244H-44V240Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-24 240H-20V244H-24V240Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4 240H0V244H-4V240Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 240H20V244H16V240Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 240H40V244H36V240Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 240H60V244H56V240Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 240H80V244H76V240Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 240H100V244H96V240Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116 240H120V244H116V240Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136 240H140V244H136V240Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156 240H160V244H156V240Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176 240H180V244H176V240Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196 240H200V244H196V240Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 240H220V244H216V240Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236 240H240V244H236V240Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-164 260H-160V264H-164V260Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-144 260H-140V264H-144V260Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-124 260H-120V264H-124V260Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-104 260H-100V264H-104V260Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-84 260H-80V264H-84V260Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-64 260H-60V264H-64V260Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-44 260H-40V264H-44V260Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-24 260H-20V264H-24V260Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4 260H0V264H-4V260Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 260H20V264H16V260Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 260H40V264H36V260Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 260H60V264H56V260Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 260H80V264H76V260Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 260H100V264H96V260Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116 260H120V264H116V260Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136 260H140V264H136V260Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156 260H160V264H156V260Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176 260H180V264H176V260Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196 260H200V264H196V260Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 260H220V264H216V260Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236 260H240V264H236V260Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-164 280H-160V284H-164V280Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-144 280H-140V284H-144V280Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-124 280H-120V284H-124V280Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-104 280H-100V284H-104V280Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-84 280H-80V284H-84V280Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-64 280H-60V284H-64V280Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-44 280H-40V284H-44V280Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-24 280H-20V284H-24V280Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4 280H0V284H-4V280Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 280H20V284H16V280Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 280H40V284H36V280Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 280H60V284H56V280Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 280H80V284H76V280Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 280H100V284H96V280Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116 280H120V284H116V280Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136 280H140V284H136V280Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156 280H160V284H156V280Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176 280H180V284H176V280Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196 280H200V284H196V280Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 280H220V284H216V280Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236 280H240V284H236V280Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-164 300H-160V304H-164V300Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-144 300H-140V304H-144V300Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-124 300H-120V304H-124V300Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-104 300H-100V304H-104V300Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-84 300H-80V304H-84V300Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-64 300H-60V304H-64V300Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-44 300H-40V304H-44V300Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-24 300H-20V304H-24V300Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4 300H0V304H-4V300Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 300H20V304H16V300Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 300H40V304H36V300Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 300H60V304H56V300Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 300H80V304H76V300Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 300H100V304H96V300Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116 300H120V304H116V300Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136 300H140V304H136V300Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156 300H160V304H156V300Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176 300H180V304H176V300Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196 300H200V304H196V300Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 300H220V304H216V300Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236 300H240V304H236V300Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-164 320H-160V324H-164V320Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-144 320H-140V324H-144V320Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-124 320H-120V324H-124V320Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-104 320H-100V324H-104V320Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-84 320H-80V324H-84V320Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-64 320H-60V324H-64V320Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-44 320H-40V324H-44V320Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-24 320H-20V324H-24V320Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4 320H0V324H-4V320Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 320H20V324H16V320Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 320H40V324H36V320Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 320H60V324H56V320Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 320H80V324H76V320Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 320H100V324H96V320Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116 320H120V324H116V320Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136 320H140V324H136V320Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156 320H160V324H156V320Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176 320H180V324H176V320Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196 320H200V324H196V320Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 320H220V324H216V320Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236 320H240V324H236V320Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-164 340H-160V344H-164V340Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-144 340H-140V344H-144V340Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-124 340H-120V344H-124V340Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-104 340H-100V344H-104V340Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-84 340H-80V344H-84V340Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-64 340H-60V344H-64V340Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-44 340H-40V344H-44V340Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-24 340H-20V344H-24V340Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4 340H0V344H-4V340Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 340H20V344H16V340Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 340H40V344H36V340Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 340H60V344H56V340Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 340H80V344H76V340Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 340H100V344H96V340Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116 340H120V344H116V340Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136 340H140V344H136V340Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156 340H160V344H156V340Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176 340H180V344H176V340Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196 340H200V344H196V340Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 340H220V344H216V340Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236 340H240V344H236V340Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-164 360H-160V364H-164V360Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-144 360H-140V364H-144V360Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-124 360H-120V364H-124V360Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-104 360H-100V364H-104V360Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-84 360H-80V364H-84V360Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-64 360H-60V364H-64V360Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-44 360H-40V364H-44V360Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-24 360H-20V364H-24V360Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4 360H0V364H-4V360Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 360H20V364H16V360Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 360H40V364H36V360Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 360H60V364H56V360Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 360H80V364H76V360Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 360H100V364H96V360Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116 360H120V364H116V360Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136 360H140V364H136V360Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156 360H160V364H156V360Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176 360H180V364H176V360Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196 360H200V364H196V360Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 360H220V364H216V360Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236 360H240V364H236V360Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-164 380H-160V384H-164V380Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-144 380H-140V384H-144V380Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-124 380H-120V384H-124V380Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-104 380H-100V384H-104V380Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-84 380H-80V384H-84V380Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-64 380H-60V384H-64V380Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-44 380H-40V384H-44V380Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-24 380H-20V384H-24V380Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4 380H0V384H-4V380Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 380H20V384H16V380Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 380H40V384H36V380Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 380H60V384H56V380Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 380H80V384H76V380Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 380H100V384H96V380Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116 380H120V384H116V380Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136 380H140V384H136V380Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156 380H160V384H156V380Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176 380H180V384H176V380Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196 380H200V384H196V380Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 380H220V384H216V380Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236 380H240V384H236V380Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-164 400H-160V404H-164V400Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-144 400H-140V404H-144V400Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-124 400H-120V404H-124V400Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-104 400H-100V404H-104V400Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-84 400H-80V404H-84V400Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-64 400H-60V404H-64V400Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-44 400H-40V404H-44V400Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-24 400H-20V404H-24V400Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4 400H0V404H-4V400Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 400H20V404H16V400Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 400H40V404H36V400Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 400H60V404H56V400Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 400H80V404H76V400Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 400H100V404H96V400Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116 400H120V404H116V400Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136 400H140V404H136V400Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156 400H160V404H156V400Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176 400H180V404H176V400Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196 400H200V404H196V400Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 400H220V404H216V400Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236 400H240V404H236V400Z",
    fill: "#A996FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_3938"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 404,
    height: 283,
    fill: "white",
    transform: "translate(-164)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotPattern1);
export default __webpack_public_path__ + "static/media/dot-pattern-1.50a0f6f742083f52aefe107549a3ebb0.svg";
export { ForwardRef as ReactComponent };